var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.reports },
    [
      _vm.type === "milestone"
        ? _c("milestone-page")
        : _vm.type === "statuses"
        ? _c("statuses-page")
        : _vm.type === "portfolio"
        ? _c("portfolio-list-page")
        : _vm.type === "schedule"
        ? _c("schedule-page")
        : _vm.type === "month"
        ? _c("month-page")
        : _c("div", [_vm._v("\n    " + _vm._s("no page ") + "\n  ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }